import { render } from "./Notify.vue?vue&type=template&id=4c710efc&scoped=true"
import script from "./Notify.vue?vue&type=script&lang=js"
export * from "./Notify.vue?vue&type=script&lang=js"

import "./Notify.vue?vue&type=style&index=0&id=4c710efc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c710efc"]])

export default __exports__